import React from 'react';
import CardTemp from './CardTemplate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faParking } from '@fortawesome/free-solid-svg-icons';
library.add(faParking);

function ColumbiaTabContent() {
  return (
    <div className="row container">
      <CardTemp
        cardLink="/ColumbiaAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" Columbia Parking Summary"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Locations:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>5</span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Varies by Location.
          </span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Waiting List:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>No</span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Wait for Parking:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            No Waiting List
          </span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Storage:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            No Storage Parking
          </span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Licenses:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Public and Employees Only
          </span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Parking Office Tel:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>212-305-4903</span>
          <br />
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            {' '}
            Email:{' '}
            <a href="mailto:parkingnyp-west@nyp.org">parkingnyp-west@nyp.org</a>
          </span>
        </span>
      />
      <CardTemp
        cardLink="/AnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" South Property Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            115 Fort Washington Avenue New York NY 10032
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Garage/Surface Lot
          </span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Valet/Self-Park
          </span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>2150 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 305-2718 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-west@nyp.org">nypparking-west@nyp.org</a>
          </span>
        </span>
      />
      <CardTemp
        cardLink="/160Answers"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" 160th Street Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            630 West 160th Street New York NY 10032
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Mon-Fri 5:45A to 1A
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>250 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Employees Only
          </span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 305-2718 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            nypparking-west@nyp.org
          </span>
        </span>
      />
      <CardTemp
        cardLink="/166Answers"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" 166th Street Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            503 West 166th Street New York NY 10032
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Mon-Fri 5:45A to 1A
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>250 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Employees Only
          </span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 305-2718 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            nypparking-west@nyp.org
          </span>
        </span>
      />
      <CardTemp
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        cardLink="/469WAnswersList"
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" 165th Street Lot"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            469 West 165th Street New York NY 10032
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Surface Lot</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Mon 5:45A - Fri 12A.
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>95 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Employees Only
          </span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 305-2718 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            nypparking-west@nyp.org
          </span>
        </span>
      />
      <CardTemp
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        cardLink="/Doctors"
        imgSrc={require('./Parking Symbol1.jpg')}
        imgTitle=" Doctors Lot"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            650 West 165th Street New York NY 10032
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Surface Lot</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            Mon-Fri 6:00A to 10P
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>185 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Doctors Only</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 305-2718 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            nypparking-west@nyp.org
          </span>
        </span>
      />
    </div>
  );
}
export default ColumbiaTabContent;
